  // --- API used by inline handlers ---
  function toggleRead(btn){
    var box = findBoxForButton(btn);
    if(!box) return;

    var lines = parseInt(box.getAttribute('data-lines') || '5', 10);
    var lh = getLineHeightPx(box);
    var collapsed = Math.round(lh * lines);
    var expanded = box.getAttribute('data-state') === 'expanded';

    if(expanded){
      box.style.maxHeight = collapsed + 'px';
      box.setAttribute('data-state','collapsed');
      if(Shopify.locale=="ar"){btn.textContent = 'اقرأ المزيد'}else{btn.textContent = 'Read more'}
      
      btn.setAttribute('aria-expanded','false');
    }else{
      box.style.maxHeight = box.scrollHeight + 'px';
      box.setAttribute('data-state','expanded');
      if(Shopify.locale=="ar"){btn.textContent = 'إظهار أقل'}else{btn.textContent = 'Show less'}
      btn.setAttribute('aria-expanded','true');
    }
  }

  function initReadBoxes(){
    var btns = document.getElementsByClassName('read-btn');
    for(var i=0;i<btns.length;i++){
      var btn = btns[i];
      var box = findBoxForButton(btn);
      if(!box) continue;

      var lines = parseInt(box.getAttribute('data-lines') || '5', 10);
      var lh = getLineHeightPx(box);
      var collapsed = Math.round(lh * lines);

      // clear prior inline styles to measure natural height
      box.style.maxHeight = '';
      box.removeAttribute('data-state');

      var needsMore = box.scrollHeight > collapsed + 1;
      if(needsMore){
        box.style.maxHeight = collapsed + 'px';
        box.setAttribute('data-state','collapsed');
        btn.hidden = false;
       if(Shopify.locale=="ar"){btn.textContent = 'اقرأ المزيد'}else{btn.textContent = 'Read more'}
        btn.setAttribute('aria-expanded','false');
      }else{
        btn.hidden = true;
      }
    }
  }

  function updateExpandedHeights(){
    var boxes = document.querySelectorAll('.read-box[data-state="expanded"]');
    for(var i=0;i<boxes.length;i++){
      boxes[i].style.maxHeight = boxes[i].scrollHeight + 'px';
    }
    // Also re-evaluate which buttons are needed after a major resize
    initReadBoxes();
  }

  // --- Helpers (no addEventListener used) ---
  function findBoxForButton(btn){
    var sel = btn.getAttribute('data-target');
    if(sel){ return document.querySelector(sel); }
    var prev = btn.previousElementSibling;
    if(prev && prev.classList.contains('read-box')) return prev;
    var next = btn.nextElementSibling;
    if(next && next.classList.contains('read-box')) return next;
    return null;
  }

  function getLineHeightPx(el){
    var cs = window.getComputedStyle(el);
    var lh = parseFloat(cs.lineHeight);
    if(isNaN(lh)){ // handle 'normal'
      var tmp = document.createElement('span');
      tmp.textContent = 'A';
      tmp.style.visibility = 'hidden';
      el.appendChild(tmp);
      lh = tmp.getBoundingClientRect().height || 20;
      el.removeChild(tmp);
    }
    return lh;
  }

  // Auto-init: safe if this script is loaded with `defer` or placed after the HTML.
  initReadBoxes();